import { fromJS } from 'immutable'
import {
  CONFIDENTIAL_EDIT_REQUEST,
  CONFIDENTIAL_EDIT_SUCCESS,
  CONFIDENTIAL_EDIT_FAILURE,
  CONFIDENTIAL_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONFIDENTIAL_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case CONFIDENTIAL_EDIT_SUCCESS:
      return state
        .set('confidentialEdit', fromJS(action.payload.updatedEmployeeConfidential))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case CONFIDENTIAL_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('confidentialEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case CONFIDENTIAL_EDIT_RESET:
      return state
        .delete('confidentialEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confidential/confidential-edit-reducer.js